export const ICredito = {
    idusu_cli:0,
    qtdeultimarecarga:0,
    tiposervico:0,
    tipotransacao:2,
    totalcredito:0,
    qtdecreditos:0,
    qtderestante:0,
    valorun:0
  }

